module.exports = __webpack_public_path__ + "img/head_jicha.2dc6daa8.png";